import { TabsItem } from 'types/tabsItem'

export const STATUS_TABS: TabsItem[] = [
  { id: 'all', title: 'All' },
  { id: 'linked', title: 'Linked' },
  { id: 'orphaned', title: 'Orphaned' },
]

export const DEFAULT_STATUS = STATUS_TABS[0]

export const SEARCH_QUERY_PARAM = 'search'
export const STATUS_QUERY_PARAM = 'status'
export const PAGE_QUERY_PARAM = 'page'
export const PER_PAGE_QUERY_PARAM = 'perPage'
